module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><div id="digiheat-slider"><header><h5 class="module-title">'+
((__t=( i18n.tc( "DigiHeat", "DigiHeat 8" ) ))==null?'':__t)+
'</h5></header><p v-show="model.modelError" class="error">ERROR! {{ model.modelError }}</p><div class="input"><defa-radio-strip v-model="digiHeatModeValue" v-bind:class="{ errorState: model.digiHeatMode === null}" :options="actionOptions" v-on:input="save($event, \'digiHeatMode\')"></defa-radio-strip><p v-show="model.digiHeatModeError" class="error">{{ model.digiHeatModeError }}</p></div></div></div>';
}
return __p;
};
